"use client";

/**
 * PortfolioSocketProvider - Global WebSocket listener for portfolio events
 *
 * Mounts once in the app layout. Listens for trade events from the backend
 * and broadcasts DOM events that any component can listen to.
 *
 * Components use window.addEventListener("portfolio:refresh", handler) to react.
 */

import { usePortfolioSocket } from "@/hooks/usePortfolioSocket";

export default function PortfolioSocketProvider() {
  // The hook manages the shared socket singleton and broadcasts DOM events
  usePortfolioSocket({ enabled: true });
  return null;
}
